import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '@app/shared/components/header/header.component';
import { ButtonDirective, ButtonGroupComponent } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'app-production-volumes',
  templateUrl: './production-volumes.component.html',
  styleUrls: ['./production-volumes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HeaderComponent,
    ButtonGroupComponent,
    ButtonDirective,
    
  ],
})
export class ProductionVolumesComponent implements OnInit {

  public totalOil: number;
  public totalWater: number;
  public totalLiquids: number;
  public totalGas: number;
  public gorScf: number;

  ngOnInit() {
    this.chooseRisked();
  }

  public chooseRisked(): void {
    this.totalOil = 3000;
    this.totalWater = 3200;
    this.totalLiquids = 6100;
    this.totalGas = 625;
    this.gorScf = 547;
  }

  public chooseUnRisked(): void {
    this.totalOil = 2720;
    this.totalWater = 2942;
    this.totalLiquids = 5662;
    this.totalGas = 578;
    this.gorScf = 533;
  }
}